import { type FillDragEvent } from '../events/types';
import { type SelectionState } from '../state/types';

import { type ReducerResponse } from './types';
import { calculateFillRange } from './utils/fill/calculate-fill-range';

export function fillDragReducer(
  state: SelectionState,
  event: FillDragEvent
): ReducerResponse {
  const sourceRange = state.selections[state.selections.length - 1];

  if (!sourceRange) {
    return { next: state, delta: { kind: 'noop' } };
  }

  // Calculate the dashed-box bounds (enforcing horizontal/vertical axis lock)
  const fillRange = calculateFillRange(sourceRange, event.cell);

  return {
    next: {
      ...state,
      lastInteractionSource: event.source
    },
    delta: {
      kind: 'fillPreview',
      source: event.source,
      sourceRange,
      fillRange
    }
  };
}
